(() => {
  const initSlider = (section) => {
    if (!section) return;

    const sliders = section.querySelectorAll(".js-elems-ticker");
    if (!sliders?.length > 0) return;

    sliders.forEach((sliderEl) => {
      const slideEls = sliderEl.querySelectorAll(".js-ticker-slide");
      if (!slideEls?.length > 0) return;

      slideEls.forEach((el) => {
        el.classList.add("swiper-slide");
      });

      const isTagsTicker = Boolean(
        sliderEl.closest(".block-tags-ticker-container")
      );

      const speed = Number(sliderEl.dataset.sliderSpeed || 12) * 1000;
      const stopAutoplaySlider =
        sliderEl.dataset.stopOnHover === "true" ? true : false;
      const isReverseDirection =
        sliderEl.dataset.reverseDirection === "true" ? true : false;

      const tickerSwiper = new Swiper(sliderEl, {
        speed: speed,
        slidesPerView: "auto",
        spaceBetween: isTagsTicker ? 8 : 12,
        autoplay: {
          delay: 0,
          reverseDirection: isReverseDirection,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        watchSlidesProgress: true,
        loop: true,
        loopedSlides: slideEls.length,
        freeMode: false,
        shortSwipes: false,
        longSwipes: false,
        allowTouchMove: false,
        simulateTouch: false,
        breakpoints: {
          750: {
            spaceBetween: isTagsTicker ? 8 : 20,
          },
        },
        a11y: {
          scrollOnFocus: false,
        },
      });

      if (stopAutoplaySlider) {
        let duration;
        let startTimer;
        let savedTranslate;

        const stopAutoplay = () => {
          if (startTimer) {
            clearTimeout(startTimer);
            startTimer = null;
          }

          tickerSwiper.autoplay.stop();

          savedTranslate = tickerSwiper.getTranslate();
          tickerSwiper.setTranslate(savedTranslate);

          const currentSlideWidth =
            tickerSwiper.slides[tickerSwiper.activeIndex]?.offsetWidth || 0;

          if (currentSlideWidth === 0) {
            duration = undefined;
            return;
          }

          const distanceRatio = Math.abs(
            (currentSlideWidth * tickerSwiper.activeIndex + savedTranslate) /
              currentSlideWidth
          );

          duration = tickerSwiper.params.speed * distanceRatio;
        };

        const startAutoplay = () => {
          if (typeof duration === "undefined") return;

          const distance =
            tickerSwiper.width * tickerSwiper.activeIndex +
            tickerSwiper.getTranslate();

          const useDuration = distance !== 0 ? duration : 0;
          duration = undefined;

          tickerSwiper.slideTo(tickerSwiper.activeIndex, useDuration);

          startTimer = setTimeout(() => {
            tickerSwiper.autoplay.start();
          }, useDuration);
        };

        sliderEl.addEventListener("mouseenter", function () {
          if (window.innerWidth < 750) return;

          stopAutoplay();
        });

        sliderEl.addEventListener("mouseleave", function () {
          if (window.innerWidth < 750) return;

          startAutoplay();
        });
      }
    });
  };

  initSlider(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (section) {
    initSlider(section.target);
  });
})();
